import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FiDialogsContentBase } from '../../fi-dialogs/fi-dialogs-content-base';
import { IFiDialogProgressMessage, IFiDialogProgressOptions } from '@fi-shared/fi-dialogs-generic/fi-dialogs-generic';
import { BehaviorSubject } from 'rxjs';
import { ProgressMessageType } from '@fi-shared/fi-dialogs-generic/progress/progress-message-type';
import { ReplaySubject } from 'rxjs';

@Component({
    selector: 'fi-dialogs-progress',
    template: `
        <p [innerText]="'dialog.please_hold_on' | fiAppText"></p>
        <div class="fi-dialogs-progress-container">
          <div class="fi-dialogs-progress-messages">
            @for (message of errorMessages$ | async; track message) {
              <div
                class="progress-message-error"
                [innerHtml]="message.value"
              ></div>
            }
            @for (message of messages$ | async; track message) {
              <div [innerHtml]="message.value"></div>
            }
          </div>
          <mat-progress-bar class="fi-dialogs-progress-bar" color="primary" [value]="progressBarValue$ | async">
          </mat-progress-bar>
        </div>
        `,
    styleUrls: ['./progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDialogsProgressComponent extends FiDialogsContentBase<IFiDialogProgressOptions, void> implements OnInit {
    messages$ = new BehaviorSubject<IFiDialogProgressMessage[]>([]);
    errorMessages$ = new BehaviorSubject<IFiDialogProgressMessage[]>([]);
    progressBarValue$ = new ReplaySubject();

    private isCompleted = false;

    ngOnInit() {
        this.data.messagePipe$.subscribe({
            next: (v) => {
                if (v.messageType === ProgressMessageType.Percentage) {
                    this.progressBarValue$.next(v.value);
                } else if (v.messageType === ProgressMessageType.Text) {
                    this.messages$.next([v]); //show only last error message
                } else if (v.messageType === ProgressMessageType.Error) {
                    const newMessages = this.errorMessages$.value;
                    newMessages.push(v);
                    this.errorMessages$.next(newMessages);
                }
            },
            complete: () => (this.isCompleted = true),
        });
    }

    isYesButtonDisabled() {
        return !this.isCompleted;
    }

    /*    isError(message: IFiDialogProgressMessage) {
        return message.messageType === ProgressMessageType.Error;
    }*/
}
